// extracted by mini-css-extract-plugin
module.exports = {"content":"style__content__SvkVE","welcomeBox":"style__welcomeBox__DDhEc"};